import { render, staticRenderFns } from "./SectionAllNews.vue?vue&type=template&id=0fe67404&scoped=true&"
import script from "./SectionAllNews.vue?vue&type=script&lang=ts&"
export * from "./SectionAllNews.vue?vue&type=script&lang=ts&"
import style0 from "./SectionAllNews.vue?vue&type=style&index=0&id=0fe67404&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe67404",
  null
  
)

export default component.exports